import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-graphical-view-pc',
  template: ''
})
export class GraphicalViewPCComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
   this.router.navigate(['/pc-database'], {
  queryParams: {
    view: 'graph',
    source: 'graphical-view'
  }
});
  }
}